import React from "react";
import { Link } from "react-router-dom";
import { useNewsList } from "../../hooks/useNews";
import { useTranslation } from "../../hooks/useTranslation";
import { hub } from "./hubSurface";

const HubNews: React.FC = () => {
  const { t } = useTranslation();
  const { data, isLoading, isError } = useNewsList({ limit: 6, offset: 0 });
  const items = data?.data ?? [];

  return (
    <section aria-labelledby="hub-news-heading">
      <div className="mb-3.5 flex items-center justify-between gap-3">
        <h2 id="hub-news-heading" className={`text-base font-semibold tracking-tight ${hub.ink}`}>
          {t("hub.newsTitle")}
        </h2>
        <Link to="/news" className={`text-xs font-medium ${hub.accent} hover:opacity-80 shrink-0`}>
          {t("hub.seeAll")}
        </Link>
      </div>

      {isLoading && (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="h-28 rounded-xl border border-[#e6e4df] bg-[#f6f5f2] animate-pulse" />
          ))}
        </div>
      )}

      {isError && <p className={`text-sm ${hub.mute}`}>{t("hub.newsError")}</p>}

      {!isLoading && !isError && items.length === 0 && (
        <p className={`rounded-xl border ${hub.border} bg-white px-4 py-5 text-center text-sm ${hub.mute}`}>
          {t("hub.newsEmpty")}
        </p>
      )}

      {items.length > 0 && (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((a) => {
            const showCover =
              Boolean(a.coverImage) && a.sourceType !== "transfer" && a.sourceType !== "digest";
            return (
              <Link
                key={a.id}
                to={`/news/${a.slug}`}
                className={`overflow-hidden rounded-xl ${hub.surface} transition-colors ${hub.surfaceHover}`}
              >
                {showCover ? (
                  <img
                    src={a.coverImage}
                    alt=""
                    className="h-36 w-full object-cover bg-[#f6f5f2]"
                    loading="lazy"
                  />
                ) : null}
                <div className="p-4">
                  <h3 className={`line-clamp-2 text-sm font-semibold leading-snug ${hub.ink}`}>
                    {a.title}
                  </h3>
                  {a.excerpt && (
                    <p className={`mt-2 line-clamp-2 text-xs leading-relaxed ${hub.mute}`}>
                      {a.excerpt}
                    </p>
                  )}
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </section>
  );
};

export default HubNews;
